import React, { useState, useEffect, useRef } from "react";
import CustomModal from "../../components/CustomModal";
import Button from "react-bootstrap/Button";
import InfoIconRed from "../../images/InfoIconRed.svg";
import "./RevertBackSmartTemp.scss";
import { updatSlideData } from "../../services/apis";

const RevertBackSmartTemp = ({
  modCurPopup,
  setModCurPopup,
  setSwitchToggleData,
  editor,
  currentSlide,
}) => {
  const handleRevertSmart = () => {
    let payLoad = { smart_template: "classic" };
    // mod
    const compEle = editor.getComponents().models;
    compEle[0].components().forEach((n) => {
      if (n.attributes.name === "Row" && n.__innerHTML().includes("Approved")) {
        // n.components(
        //   '<div data-gjs-highlightable="true"   draggable="true" class="gjs-cell"></div>'
        // );
        const existLabel = n.getLastChild();

        if (n.attributes.name !== "Cell") {
          existLabel.remove();
        }
        let attr = n.getAttributes();
        delete attr.modularBlockIndex;
        delete attr.modularBlock;
        n.setAttributes(attr);

        n.setStyle({
          //  "background-color": "#fff",
          "background-image": "none",
          border: "none",
        });
        n.set({
          removable: true,
          draggable: true,
          copyable: true,
        });
        const retainCell = n.getLastChild();
        retainCell.setStyle({ display: "block" });
      }
    });

    updatSlideData(
      currentSlide?.master?.slideid._id,
      payLoad,
      (response, err, errorCode) => {
        if (err) {
          // setIsloading(false);
        } else {
          // setIsloading(false);
        }
      }
    );
    setModCurPopup(false);
    setSwitchToggleData("classic");
    let compSelected = editor.getSelected() || {};
    if (
      compSelected?.attributes?.name === "Row" &&
      compSelected?.components().length === 1
    ) {
      //compSelected.set({ unstylable: ["modular_content"] });
      const propMod = document.querySelector(".gjs-sm-sector__modular_content");
      propMod.classList.remove("d-block");
      propMod.classList.add("d-none");
      editor.StyleManager.render();
    }
  };
  return (
    <CustomModal
      displayModal={modCurPopup}
      hideModal={() => {}}
      title={""}
      size="sm"
      dilogClassName="import-pkg-modal"
      keyboard={false}
    >
      <div className="row">
        <div className="modular-heading ">
          <img src={InfoIconRed} height={12} alt="Info Icon" />
          <span className="modular-title">Modular to Static</span>
        </div>
        <div className="modular-content">
          Switch will lead to loss of all module placeholders.
          <div className="modular-confirmation">Are you sure?</div>
        </div>
        <div className="col-md-12 importFooter">
          <button
            className="btn close-import btn btn-primary"
            onClick={() => setModCurPopup(false)}
          >
            CANCEL
          </button>
          <Button className="btn import-pkg" onClick={handleRevertSmart}>
            PROCEED
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default RevertBackSmartTemp;
